import { usePreviewPanelsContext } from "../preview-panel-context";

const noop = (props?: any) => {};

export const usePreviewPanelsActions = () => {
	const context = usePreviewPanelsContext();
	if (!context) {
		return {
			open: noop,
			close: noop,
			swap: noop,
			setPanelWidth: noop,
		};
	}

	return {
		open: context.open,
		close: context.close,
		swap: context.swap,
		setPanelWidth: context.setPanelWidth,
	};
};
